module.exports = __webpack_public_path__ + "img/lb.489847d1.jpg";